<template>
  <section class="staff-data">
    <WAvatar aria-hidden :url="staff.photo" size="large" />
    <div>
      <WTitle class="staff-data__title" size="medium" variant="heavy">{{
        staff.name
      }}</WTitle>
      <DStaffStatus :status="staff.status" />
    </div>
  </section>
</template>
<script>
import { WAvatar, WTitle } from '@alice-health/wonderland-vue'

import { DStaffStatus } from '..'

export default {
  components: { DStaffStatus, WAvatar, WTitle },
  props: {
    staff: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.staff-data {
  display: flex;
  align-items: center;
  gap: var(--gl-spacing-02);
  &__title {
    margin-bottom: var(--gl-spacing-01);
  }
}
</style>
